import ApprovalHolidayApplicationPage from './ApprovalHolidayApplicationPage'

export default ApprovalHolidayApplicationPage